<app-header label="database.createOrganizationPage.createOrganization" icon="pi-th-large"></app-header>
<div class="w-full surface-0 shadow-4 p-3 pt-2 border-round">
    <div class="text-xl mb-3">{{ 'database.createOrganizationPage.form.title' | translate }}</div>
    <div [formGroup]="form" class="input-grid input-grid-gaps">
        <app-date-input
            id="validFrom"
            [prefix]="prefix"
            [form]="form"
            class="fr-2"
        ></app-date-input>
        <app-date-input
            id="systemFrom"
            [prefix]="prefix"
            [form]="form"
            class="fr-2"
        ></app-date-input>
        <app-date-input
            id="systemTo"
            [prefix]="prefix"
            [form]="form"
            class="fr-2"
        ></app-date-input>
        <app-text-input
            id="name"
            [prefix]="prefix"
            [form]="form"
            class="fr-3"
        ></app-text-input>
        <app-text-input
            id="ic"
            [prefix]="prefix"
            [form]="form"
            class="fr-2"
        ></app-text-input>
        <app-text-input
            id="dic"
            [prefix]="prefix"
            [form]="form"
            class="fr-2"
        ></app-text-input>
        <app-web-input
            [prefix]="prefix"
            [form]="form"
            class="fr-2"
        ></app-web-input>
        <app-phone-input
            [label]="prefix + 'fields.phone'"
            [form]="form"
            class="fr-2"
        ></app-phone-input>
        <app-email-input
            [prefix]="prefix"
            [form]="form"
            class="fr-3"
        ></app-email-input>
        <app-select-input
            id="country"
            [staticOptions]="countriesOptions"
            [form]="form"
            [label]="prefix + 'fields.country'"
            class="fr-3"
            labelKey="name"
            valueKey="name">
        </app-select-input>
        @if (featureOn.PARENT_ORGANIZATION) {
            <app-select-input
                id="parentOrganizationId"
                [form]="form"
                [infiniteScroll]="store.parentOrganizationScroll()"
                [label]="prefix + 'fields.parentOrganizationId'"
                class="fr-3"
                valueKey="id"
                labelKey="name"
                dataKey="id"
                filterBy="name"
            ></app-select-input>
        }
        <app-address-input
            id="address"
            [form]="form"
            class="fr-10"
        ></app-address-input>
    </div>
</div>

<div class="buttons">
    <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="hide()"></app-action-buttons>
</div>
